import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../apiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

const Eventos = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showRegistroModal, setShowRegistroModal] = useState(false);
  const [showParticipantesModal, setShowParticipantesModal] = useState(false);
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
  const [telefono, setTelefono] = useState("");
  const [nombreParticipante, setNombreParticipante] = useState("");
  const [evidencias, setEvidencias] = useState(null);
  const [participantes, setParticipantes] = useState([]);
  const [meta, setMeta] = useState(0);
  const [progreso, setProgreso] = useState(0);
  const [metaEvento, setMetaEvento] = useState(0);
  const [showEvidenciaModal, setShowEvidenciaModal] = useState(false);
  const [evidenciaSeleccionada, setEvidenciaSeleccionada] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const eventosPorPagina = 3; //
  const totalPaginas = Math.ceil(eventos.length / eventosPorPagina);
  const navigate = useNavigate();
  const [niveles, setNiveles] = useState([]);
  const [nivelesSeleccionados, setNivelesSeleccionados] = useState([]);
  const [showInvitacionModal, setShowInvitacionModal] = useState(false);
  //const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
//const [mostrarModalNiveles, setMostrarModalNiveles] = useState(false);


  const obtenerParticipantes = async (eventoId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Eventos/ParticipantesEvento?eventoId=${eventoId}`, {
            withCredentials: true,
        });

        setParticipantes(response.data.participantes);
        setMetaEvento(response.data.meta);
        setProgreso(response.data.progreso);
        setShowParticipantesModal(true);
    } catch (error) {
        console.error("Error al obtener participantes:", error);
        alert("Error al cargar los participantes.");
    }
};

const verEvidencia = (rutaEvidencia) => {
    if (!rutaEvidencia) {
        alert("No hay evidencia disponible.");
        return;
    }

    setEvidenciaSeleccionada(`${API_BASE_URL}/Eventos/VerEvidencia?filePath=${rutaEvidencia}`);
    setShowEvidenciaModal(true);
};

  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Eventos/EventosUsuario`, {
          withCredentials: true,
        });
        setEventos(response.data);
      } catch (err) {
        console.error("Error al obtener eventos:", err);
        setError("No se pudieron cargar los eventos.");
      } finally {
        setLoading(false);
      }
    };
    fetchEventos();
  }, []);

  // SE ABRE EL MODAL DE REGISTRO Y SE GUARDA EVIDENCIA DEL PARTICIPANTE
  const abrirModalRegistro = (evento) => {
////////////////////////////////////////////////////////////////////////////////////////////////////
    //  EVENTO FINALIZADO?? CANCELADO??
    if (evento.estatusEvento === "Finalizado" || evento.estatusEvento === "Cancelado") {
      Swal.fire({
          title: 'Acción no permitida',
          text: `No se pueden registrar participantes en un evento ${evento.estatusEvento.toLowerCase()}.`,
          //icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
          background: '#081b29',
          color: '#ffffff',
      });
      return;
  }
    setEventoSeleccionado(evento);
    setTelefono("");
    setNombreParticipante("");
    setEvidencias([]);
    setShowRegistroModal(true);
};

const validarTelefono = async () => {
    if (!telefono) return;
    try {
        const response = await axios.get(`${API_BASE_URL}/Eventos/ValidarTelefono?telefono=${telefono}`);
        if (response.data.exists) {
            setNombreParticipante(response.data.nombre);
        } else {
            setNombreParticipante("No registrado");
        }
    } catch (error) {
        console.error("Error al validar teléfono:", error);
        setNombreParticipante("Error en validación");
    }
};

const registrarParticipante = async () => {
    if (!telefono) {
      toast(" Por favor, ingresa un número de teléfono.", {
        toast: true, // Activar el modo toast
        position: 'top-right', // Posiciona el toast en la esquina superior derecha
        showConfirmButton: false, // No mostrar el botón de confirmar
        timer: 3000, // El toast desaparece después de 3 segundos
        theme: "#ffffff",
        style: {
          backgroundColor: "#081b29",
          color: "#ffffff",
          fontWeight: "bold",
          borderRadius: "8px",
      },
    });
    return;
}

    let formData = new FormData();
    formData.append("eventoId", eventoSeleccionado.id);
    formData.append("telefono", telefono);

    if (evidencias.length > 0) {
        for (let i = 0; i < evidencias.length; i++) {
            formData.append("evidencias", evidencias[i]); //  Ahora maneja múltiples archivos
        }
    }

    try {
    const response = await axios.post(`${API_BASE_URL}/Eventos/RegistrarParticipante`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
    });

    Swal.fire({
        title: 'Asistencia registrada con éxito',
        //text: response.data.message,
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
        background: '#081b29', // Color de fondo oscuro
        color: '#ffffff', // Color del texto blanco para mayor contraste
    });
    setShowRegistroModal(false);
} catch (error) {
    console.error("Error al registrar participante:", error);
    Swal.fire({
        title: 'Verifique datos y evidencia (Solo acepta .png, .jpg, .jpeg)',
        //Stext: error.response?.data?.message || "Error al registrar el participante.",
        icon: 'error',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cerrar',
        background: '#081b29', // Color de fondo oscuro
        color: '#ffffff' // Color del texto blanco
    });
  }
};

  const abrirModalParticipantes = async (evento) => {
    setEventoSeleccionado(evento);
    try {
      const response = await axios.get(`${API_BASE_URL}/Eventos/ParticipantesEvento?eventoId=${evento.id}`);
      setParticipantes(response.data.participantes);
      setMeta(response.data.meta);
      setProgreso(response.data.progreso);
      setShowParticipantesModal(true);
    } catch (error) {
      console.error("Error al obtener participantes:", error);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(3); // Cantidad de eventos por página, ajustable según necesidades

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEvents = eventos.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
  const fetchNiveles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Formulario/NivelParticipante`);
      setNiveles(response.data);
    } catch (error) {
      console.error("Error al cargar niveles:", error);
    }
  };

  fetchNiveles();
}, []);

const enviarInvitacion = async () => {
  if (!eventoSeleccionado || nivelesSeleccionados.length === 0) {
    toast.error("Selecciona al menos un nivel y un evento.");
    return;
  }

  try {
    const payload = {
      eventoId: eventoSeleccionado.id,
      niveles: nivelesSeleccionados,
    };

    const response = await axios.post(`${API_BASE_URL}/Eventos/InvitacionPorNivelParticipantes`, payload, {
      withCredentials: true,
    });

    toast.success(response.data.message || "Invitaciones enviadas correctamente.");
    setShowInvitacionModal(false);
    setNivelesSeleccionados([]);
  } catch (error) {
    console.error("Error al enviar invitaciones:", error);
    toast.error("Error al enviar invitaciones.");
  }
};


// 👉 Al dar clic al botón de invitación
const abrirModalNiveles = (evento) => {
  setEventoSeleccionado(evento); // Esto es clave
  setShowInvitacionModal(true);
};

const handleNivelChange = (nivelId) => {
  setNivelesSeleccionados(prev =>
    prev.includes(nivelId)
      ? prev.filter(id => id !== nivelId)
      : [...prev, nivelId]
  );
};




  return (

    <div className="container mt-4">
    <img src="/img/monytorlogoa.png" alt="Logo" className="login-image" />
    <h2 className="text-white text-center">Eventos Asignados</h2>

    {/*  Mostrar total de eventos */}
    <h4 className="mt-3 text-white px-4 py-2 rounded-lg inline-block">
          Total de eventos: {eventos.length}
        </h4>


      {loading && <p className="text-white">Cargando eventos...</p>}
      {error && <p className="text-danger">{error}</p>}

      <div className="d-flex justify-content-between">
          <button
            type="button"
            onClick={() => navigate("/menu")}
            className="btn btn-secondary"
          >
            Regresar al Menú
          </button>
        </div>


      {eventos.length > 0 && (
        <table className="table table-dark table-striped mt-3">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Meta</th>
              <th>Estatus</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {eventos.map((evento) => (
              <tr key={evento.id}>
                <td>{evento.nombreEvento}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{evento.descripcionEvento}</td>
                <td>{new Date(evento.fechaInicio).toLocaleString()}</td>
                <td>{new Date(evento.fechaFin).toLocaleString()}</td>
                <td>{evento.meta}</td>
                <td>
                  <span className={`badge bg-${evento.estatusEvento === "Activo" ? "success" : "danger"}`}>
                    {evento.estatusEvento}
                  </span>
                </td>
                <td>
                  <button className="btn btn-primary btn-sm me-2" onClick={() => abrirModalRegistro(evento)}>
                    Registrar Participante
                  </button>
                    <button className="btn btn-warning btn-sm" onClick={() => obtenerParticipantes(evento.id)}>
                        Ver Participantes
                    </button>
                    <button className="btn btn-warning btn-sm" onClick={() => abrirModalNiveles(evento)}>
                    Enviar Invitación a Participantes
                    </button>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

{showRegistroModal && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
    //onClick={() => setShowRegistroModal(false)} // Cierra modal al hacer clic en el fondo
  >
    <div
      className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-[90vw] md:max-w-lg w-full relative text-white max-h-screen overflow-y-auto"
      onClick={(e) => e.stopPropagation()} // Evita cerrar al hacer clic dentro
    >
      {/* Encabezado */}
      <div className="flex justify-between items-center border-b pb-3">
        <h3 className="text-lg font-semibold">Registrar Participante</h3>
        <button
          onClick={() => setShowRegistroModal(false)}
          className="text-gray-500 hover:text-white text-xl"
        >
          ✖
        </button>
      </div>

      {/* Cuerpo del Modal */}
      <div className="mt-4 space-y-3">
        {/* Teléfono */}
        <input
          type="text"
          className="w-full p-2 border border-gray-400 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Teléfono"
          value={telefono}
          onChange={(e) => setTelefono(e.target.value)}
          onBlur={validarTelefono}
        />

        {/* Nombre del Participante (Solo Lectura) */}
        <input
          type="text"
          className="w-full p-2 border border-gray-400 rounded bg-gray-300 text-black focus:outline-none"
          value={nombreParticipante}
          readOnly
        />

        {/* Subida de Archivos (Múltiples) */}
        <input
          type="file"
          className="w-full p-2 border border-gray-400 rounded bg-gray-100 text-black focus:outline-none"
          multiple
          onChange={(e) => setEvidencias([...e.target.files])}
        />
      </div>

      {/* Botones de Acción */}
      <div className="mt-6 flex justify-end gap-2">
        <button
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
          onClick={() => setShowRegistroModal(false)}
        >
          Cancelar
        </button>

        <button
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
          onClick={registrarParticipante}
        >
          Registrar
        </button>
      </div>
    </div>
  </div>
)}

{/* Modal para Ver Participantes */}
{showParticipantesModal && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
    //onClick={() => setShowParticipantesModal(false)} // Cierra modal al hacer
  >
    <div
      className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-[95vw] md:max-w-3xl w-full text-black relative max-h-screen overflow-y-auto
  >"
      onClick={(e) => e.stopPropagation()} // Evita cerrar al hacer clic dentro
    >
      {/* Encabezado */}
      <div className="flex justify-between items-center border-b pb-3">
        <h3 className="text-lg font-semibold text-white">Participantes del Evento</h3>
        <button
          onClick={() => setShowParticipantesModal(false)}
          className="text-gray-600 hover:text-black text-xl"
        >
          ✖
        </button>
      </div>

      {/* Cuerpo del Modal */}
      <div className="mt-4 space-y-4">
        {/* Meta y Avance */}
        <div className="flex flex-col md:flex-row justify-between">
          <div>
            <strong className= "text-white">Meta del Evento:</strong> <span className="text-white">{metaEvento}</span>
          </div>
          <div>
            <strong className= "text-white">Avance:</strong> <span className="text-white">{participantes.length}</span>
          </div>
        </div>

        {/* Progreso con barra dinámica */}
        <div className="w-full bg-gray-300 rounded-full h-4 overflow-hidden">
          <div
            className={`h-full text-xs text-center text-white rounded-full transition-all ${
              progreso < 50 ? "bg-red-500" : progreso < 80 ? "bg-yellow-500" : "bg-green-500"
            }`}
            style={{ width: `${progreso}%` }}
          ></div>
        </div>

        {/* Tabla de Participantes */}
        <div className="overflow-auto ">
          <table className="table-auto w-full border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="px-4 py-2 text-center border">Nombre</th>
                <th className="px-4 py-2 text-center border">Evidencia</th>
              </tr>
            </thead>
            <tbody>
              {participantes.length > 0 ? (
                participantes.map((p, index) => (
                  <tr key={index} className="border text-center">
                    <td className="px-4 py-2 text-white">{p.nombre}</td>
                    <td className="px-4 py-2">
                      {p.evidencia1 ? (
                        <button
                          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition"
                          onClick={() => verEvidencia(p.evidencia1)}
                        >
                          Ver Evidencia
                        </button>
                      ) : (
                        <span className="text-gray-500">Sin evidencia</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center text-white py-3">
                    No hay participantes registrados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Botón de Cierre */}
      <div className="mt-6 flex justify-end">
        <button
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition"
          onClick={() => setShowParticipantesModal(false)}
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}

{/* Modal para Ver Evidencia */}
{showEvidenciaModal && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
    onClick={() => setShowEvidenciaModal(false)}
  >
    <div
      className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-3xl w-full relative text-white border border-gray-600 max-h-screen overflow-y-auto
  >"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Encabezado */}
      <div className="flex justify-between items-center border-b border-gray-500 pb-2">
        <h5 className="text-lg font-semibold">Evidencia</h5>
        <button
          onClick={() => setShowEvidenciaModal(false)}
          className="text-gray-400 hover:text-white text-lg"
        >
          ✖
        </button>
      </div>

      {/* Contenido del Modal */}
      <div className="modal-body text-center mt-4">
        {evidenciaSeleccionada.endsWith(".pdf") ? (
          <iframe
            src={evidenciaSeleccionada}
            className="w-full max-h-[500px] overflow-auto rounded"
            style={{ minHeight: "400px" }}
          />
        ) : (
          <img
            src={evidenciaSeleccionada}
            className="max-w-full max-h-[500px] rounded shadow-md"
            alt="Evidencia"
          />
        )}
      </div>

      {/* Botón de Cerrar */}
      <div className="mt-4 flex justify-end">
        <button
          className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
          onClick={() => setShowEvidenciaModal(false)}
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}

{/* Invitacion a participantes */}
{showInvitacionModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4">
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-black">
      <h3 className="text-lg font-semibold mb-4">Selecciona niveles</h3>

      {niveles.map((nivel) => (
        <div key={nivel.id} className="mb-2">
          <label className="text-black">
            <input
              type="checkbox"
              className="mr-2"
              value={nivel.id}
              checked={nivelesSeleccionados.includes(nivel.id)}
              onChange={() => {
                setNivelesSeleccionados((prev) =>
                  prev.includes(nivel.id)
                    ? prev.filter((n) => n !== nivel.id)
                    : [...prev, nivel.id]
                );
              }}
            />
            {nivel.nombre}
          </label>
        </div>
      ))}


      <div className="mt-4 flex justify-end gap-2">
        <button
          className="bg-gray-500 text-white px-4 py-2 rounded"
          onClick={() => setShowInvitacionModal(false)}

        >
          Cancelar
        </button>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={enviarInvitacion}
        >
          Enviar Invitación
        </button>
      </div>
    </div>
  </div>
)}


</div>

  );
};

export default Eventos;